<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <!-- <v-flex xs12>
        <v-img
          :src="require('../assets/logo.svg')"
          class="my-3"
          contain
          height="200"
        ></v-img>
      </v-flex> -->

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          Login to import
        </h1>

        <v-btn v-if="!user" @click.prevent="signInWithGoogle" color="success">Log in with Google</v-btn>
            
        <v-btn flat v-if="user" @click.prevent="logOutWithGoogle">
          <span class="pr-2">SIGN OUT</span> 
          <i class="material-icons pl-1">input</i>
        </v-btn>
        
      </v-flex>

      

    </v-layout>
  </v-container>
</template>

<script>
// if someone is signed in can via the iframe another user see /import
import db from '../firebaseConfig.js'
import firebase from 'firebase'

export default {
    title: 'Login',
    data () {
      return {
          user: firebase.auth().currentUser,
      }
    },
    methods: {
      signInWithGoogle() {
          var provider = new firebase.auth.GoogleAuthProvider()
          firebase.auth().signInWithPopup(provider)
              .catch((err) => alert(err.message || err))
          firebase.auth().onAuthStateChanged((user) => {
              console.log('Logged in as:', user.email, user.uid)
              this.user = firebase.auth().currentUser
              // this.$router.go()
              this.$router.push('import')
          })
      },
      logOutWithGoogle() {
          firebase.auth().signOut()
          this.$router.go()
      }
    }
}
</script>

<style>

</style>
